export enum StorageKeys {
  Pagination = 'pagination',
  ActivePreset = 'presetId',
  // Todo this is going to be stored on backend side
  Presets = 'presets',
  SportId = 'sportId',
  TableStateHookVersion = 'tableHookCurrentVersion',
}

export const getStorageValue = (key: string, name?: StorageKeys) => {
  try {
    const stored = JSON.parse(localStorage.getItem(key));
    return name ? stored?.[name] : stored;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.debug(`getStorageValue failed to retrieve ${key}`);
    return null;
  }
};

export const setStorageValue = (key: string, value: any, name?: StorageKeys) => {
  if (name) {
    let previous;
    try {
      previous = JSON.parse(localStorage.getItem(key));
    } catch (e) {
      previous = {};
    }

    localStorage.setItem(key, JSON.stringify({ ...previous, [name]: value || null }));
  } else {
    localStorage.setItem(key, JSON.stringify(value || null));
  }
};

/** Wrappers for table state storage */
export const setPaginationState = (key: string, pagination: BasicPaginationProps) =>
  setStorageValue(key, pagination, StorageKeys.Pagination);

export const setCustomPresets = (key: string, presets: Array<TablePreset>) =>
  setStorageValue(key, presets, StorageKeys.Presets);

export const storeActivePreset = (key, presetId: number) =>
  setStorageValue(key, presetId, StorageKeys.ActivePreset);

export const getPaginationState = (key: string): BasicPaginationProps =>
  getStorageValue(key, StorageKeys.Pagination);

export const clearStorageKey = (key: string) => {
  localStorage.removeItem(key);
};
